document.addEventListener('DOMContentLoaded', () => {
  const toggleBtn = document.getElementById('NpacMenuToggle');
  const drawer = document.getElementById('NpacMobileDrawer');
  const closeBtn = document.getElementById('NpacDrawerClose');
  const backdrop = document.getElementById('NpacDrawerBackdrop');

  if (toggleBtn && drawer) {
    function openMenu() {
      drawer.classList.add('is-open');
      toggleBtn.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('npac-drawer-open');
    }

    function closeMenu() {
      drawer.classList.remove('is-open');
      toggleBtn.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('npac-drawer-open');
    }

    toggleBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      if (drawer.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    if (backdrop) backdrop.addEventListener('click', closeMenu);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeMenu();
      }
    });

    const drawerLinks = drawer.querySelectorAll('a');
    drawerLinks.forEach((link) => {
      link.addEventListener('click', closeMenu);
    });
  }
});